import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { CardTitle } from 'material-ui/Card'
import RaisedButton from 'material-ui/RaisedButton'
import CircularProgress from 'material-ui/CircularProgress'
import AlertAddAlert from 'material-ui/svg-icons/alert/add-alert'
import api from '../../api'
import { setSnackbarMessage } from '../../actions/snackbar'

class CheckinReminders extends Component<any, any> {
  constructor () {
    super()
    this.state = {
      reminders: null,
      sent: false
    }
  }

  componentWillMount () {
    api
      .get('admin/checkin_reminders')
      .then((res) => res.json())
      .then((data) => {
        this.setState({ reminders: data })
      })
  }

  handleSend (e) {
    e.preventDefault()

    api.post('admin/checkin_reminders').then((res) => {
      if (res.ok) {
        this.setState({ sent: true })
      } else {
        this.props.setSnackbarMessage('Unable to send checkin reminders')
      }
    })
  }

  render () {
    const { reminders, sent } = this.state

    if (reminders === null) {
      return <CircularProgress />
    }

    if (reminders.length > 0 || sent) {
      return (
        <div>
          <CardTitle title='Checkin Reminders' style={{ paddingLeft: 0 }} />
          <p>Checkin reminders are being sent...</p>
        </div>
      )
    }

    return (
      <div>
        <CardTitle title='Checkin Reminders' style={{ paddingLeft: 0 }} />
        <p>
          Use the button below to start the automatic reminder agent, which will
          create a checkin comment for each user who:
        </p>
        <ul>
          <li>Is in an active session</li>
          <li>
            Is in a session configured to receive automatic reminders (start/end
            dates)
          </li>
          <li>Has not checked in yet today</li>
        </ul>
        <RaisedButton
          label='Send Reminders'
          primary
          icon={<AlertAddAlert />}
          onClick={(e) => this.handleSend(e)}
        />
      </div>
    )
  }
}

// @ts-ignore
CheckinReminders.propTypes = {
  setSnackbarMessage: PropTypes.func.isRequired
}

export default connect(null, { setSnackbarMessage })(CheckinReminders)
